import SEOHead from "@/components/SEOHead";
import ProductLadder from "@/components/ProductLadder";
import { organizationLd } from "@/lib/seo";

export default function Pricing() {
  return (
    <div data-testid="pricing-page" className="bg-gradient-to-b from-white to-slate-50 py-14 sm:py-20">
      <SEOHead
        title="Pricing — Free AI Fit Check, ₹99 Report, ₹499 Expert Call, ₹999 Decision Pack"
        description="Transparent pricing at CollegeUnlock. Start with a free AI College Fit Check, then choose the ₹99 Regret Risk Report, ₹499 Expert Admission Call, or ₹999 Admission Decision Pack."
        canonicalPath="/pricing"
        jsonLd={[organizationLd()]}
      />
      <ProductLadder />
    </div>
  );
}
